export default __webpack_public_path__ + "static/media/ic_down.cfd3d8ad.svg";